import { createBusinessComponent } from '../utils/create';
export default createBusinessComponent({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('header', {
      class: [_vm.b('main'), {
        'tj-hairline--bottom': _vm.isShowBottomLine
      }],
      style: _vm.contentStyle
    }, [_c('div', {
      class: _vm.b('content')
    }, [_vm._t("left-btn", [!_vm.isHiddenLeftBtn ? _c('div', {
      class: [_vm.b('m-bar-btn'), _vm.b('m-bar-btn-left')],
      on: {
        "click": _vm.leftClick
      }
    }, [_c('span', {
      class: _vm.b({
        'u-left-btn-black': _vm.leftBlack,
        'u-left-btn': !_vm.leftBlack
      })
    })]) : _vm._e()]), _c('div', {
      class: _vm.b('m-title')
    }, [_vm._t("default", [_c('span', {
      class: _vm.b('u-title')
    }, [_vm._v(_vm._s(_vm.title))])])], 2), _vm._t("right-btn", [_vm.rightTitle ? _c('div', {
      class: [_vm.b('m-bar-btn'), _vm.b('m-bar-btn-right')],
      on: {
        "click": _vm.rightClick
      }
    }, [_vm._v(_vm._s(_vm.rightTitle))]) : _vm._e()])], 2)]);
  },
  // name属性为必填项，用于关联组件名称，不声明将无法关联tjb-app-header，样式和调用时都会出问题
  name: 'app-header',
  props: ['title', 'rightTitle', 'isHiddenLeftBtn', 'isCheckLeftCallback', 'backgroundColor', 'isShowBottomLine', 'color', 'paddingTop', 'height', 'leftBlack'],
  computed: {
    contentStyle: function contentStyle() {
      return {
        backgroundColor: this.backgroundColor,
        color: this.color,
        height: this.height,
        paddingTop: this.paddingTop
      };
    }
  },
  methods: {
    gobackForCheck: function gobackForCheck(backIndex) {
      var prevPage = window.location.href;
      window.history.go(backIndex);
      this.clearTime = setTimeout(function () {
        if (window.location.href === prevPage) {
          // tjBridge.quit()
          window.bridge.quit();
        }
      }, 500);
    },
    leftClick: function leftClick() {
      var _this = this;

      if (this.isCheckLeftCallback) {
        this.$emit('leftClick', function (backIndex) {
          if (!backIndex) {
            backIndex = -1;
          }

          _this.gobackForCheck(backIndex);
        });
      } else {
        this.gobackForCheck(-1);
      }
    },
    rightClick: function rightClick() {
      this.$emit('rightClick', null);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.clearTime) {
      clearTimeout(this.clearTime);
    }
  }
});